/**
 * 统一获取 Mapbox Token
 * 优先级：运行时配置 > 编译期环境变量 > localStorage
 */
export function getMapboxToken() {
  const runtime =
    (typeof window !== 'undefined' && window.RUNTIME_CONFIG && window.RUNTIME_CONFIG.MAPBOX_TOKEN) || '';
  const envToken = process.env.REACT_APP_MAPBOX_TOKEN || '';
  const stored =
    (typeof window !== 'undefined' && window.localStorage && localStorage.getItem('mapbox_token')) || '';

  const token = [runtime, envToken, stored]
    .map((v) => (v || '').trim())
    .find((v) => v && v.startsWith('pk.'));

  return token || '';
}

/**
 * 将 token 应用到 mapboxgl，并返回是否成功
 */
export function applyMapboxToken(mapboxgl) {
  const token = getMapboxToken();
  if (!token) {
    console.warn('Mapbox token未设置，地图可能无法正常显示。请配置 frontend/.env.production 或 public/runtime-config.js');
    return false;
  }
  mapboxgl.accessToken = token;
  return true;
}
